import Axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';
import util from 'util';
import Const from '../const';

let loadingCount = 0;

const serverUrl =
  Const.serverProtocol + '://' + Const.serverIp + ':' + Const.serverPort;

const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');

const makeUrl = (url, params) => {
  var result = serverUrl + url;
  if (params === null) return result;
  params.forEach((param) => {
    result = util.format(result, param);
  });
  return result;
};

const imageUrl = (idx) => {
  return serverUrl + '/file/' + idx;
};

const httpExec = (method, url, data, hideLoading) => {
  if (!hideLoading) {
    loadingCount++;
    if (loadingCount === 1)
      global.document.getElementById('loadingSpinner').style.display = 'block';
  }

  const headers =
  url === 'https://nnlog.nyamnyampay.com/nnlog' ? 
  {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  :
  (userInfo && userInfo.id) ? {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // 'Branch-Idx': userInfo.branchIdx,
    // 'User-Idx': userInfo.idx,
  }
  :
  {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }

  return new Promise((resolve, reject) => {
    Axios({
      method: method,
      url: url,
      data: data,
      withCredentials: true,
      headers,
    })
      .then((response) => {
        // if (
        //   url === serverUrl + httpUrl.login ||
        //   url === serverUrl + httpUrl.logout
        // ) {
        // } else {
        //   if (
        //     (method === 'PUT' || method === 'POST' || method === 'DELETE') &&
        //     response.data.result === 'SUCCESS'
        //   ) {
        //     alert('완료');
        //   }
        // }
        resolve(response.data);
        if (!hideLoading) {
          loadingCount--;
          if (loadingCount === 0)
            global.document.getElementById('loadingSpinner').style.display =
              'none';
        }
      })
      .catch((error) => {
        if (error.message.includes('401')) {
          reactLocalStorage.remove('adminUser');
          global.location.href = '/';
        }
        // if (error.response.data.message === 'E10003') {
        //   if (!isAlertOpened) {
        //     isAlertOpened = true;
        //     alert('장기간 미사용으로 자동 로그아웃 되었습니다.');
        //     global.location.href = '/';
        //   }
        // } else if (error.response.data.data === 'E10003') {
        //   if (!isAlertOpened) {
        //     isAlertOpened = true;
        //     alert('접근 권한이 없습니다. 로그인 해주세요.');
        //     global.location.href = '/';
        //   }
        // }
        // alert(JSON.stringify(error));
        reject(error);
        if (!hideLoading) {
          loadingCount--;
          if (loadingCount === 0)
            global.document.getElementById('loadingSpinner').style.display =
              'none';
        }
      });
  });
};

const httpGet = (url, params, data, hideLoading) => {
  return httpExec('GET', makeUrl(url, params), data, hideLoading);
  // return new Promise((resolve, reject) => {
  //   Axios.get(makeUrl(url, params), data)
  //     .then(response => {
  //       resolve(response.data);
  //     })
  //     .catch(error => {
  //       reject(error);
  //     });
  // });
};

const httpPut = (url, params, data, hideLoading) => {
  return httpExec('PUT', makeUrl(url, params), data, hideLoading);
  // return new Promise((resolve, reject) => {
  //   Axios.put(makeUrl(url, params), data)
  //     .then(response => {
  //       resolve(response.data);
  //     })
  //     .catch(error => {
  //       reject(error);
  //     });
  // });
};

const httpPost = (url, params, data, hideLoading) => {
  return httpExec('POST', makeUrl(url, params), data, hideLoading);
  // return new Promise((resolve, reject) => {
  //   Axios.post(makeUrl(url, params), data)
  //     .then(response => {
  //       resolve(response.data);
  //     })
  //     .catch(error => {
  //       reject(error);
  //     });
  // });
};

const httpUrl = {
  login: '/login',
  logout: '/logout',
  frUpdate: '/fr/update',
  passwordChange: '/user/changePassword',
  setConsentDocId: '/fr/setconsentdocid',

  branch: '/branch/%d',
  branchList: '/branch/list',
  //system
  systemStatus: '/system/status?idx=%s',

  //cash
  riderNCash: '/user/ncash',
  autoCharge: '/fr/ncashAutoCharge',
  autoChargeUpdate: '/fr/ncashAutoCharge/update',
  issuePaystoryBillkey: '/paystory/issue/billkey',
  payPaystoryBillkey: '/paystory/billkey/pay',
  allList: '/user/ncashList/1',
  // useList:
  //   "/fr/stat/list?pageSize=%d&pageNum=%d&startDate=%s&endDate=%s&kind=%d",
  useList:
    '/history/day/listByHourly?endDate=%s&pageNum=%s&pageSize=%s&startDate=%s',
  useMonthList:
    '/history/month/listByHourly?endDate=%s&pageNum=%s&pageSize=%s&startDate=%s',
  //card
  cardPaymentList:
    '/order/cardPaymentListByFr?pageSize=%d&pageNum=%d&endDate=%s&startDate=%s',
  cardCharge: '/payment/card/charge',
  cardStaticsList:
    '/history/card-payment/daily?endDate=%s&pageNum=%s&pageSize=%s&startDate=%s',

  //order
  orderCreate: '/order/create',
  orderAwaitCreate: '/order/await/create/%s',
  orderAwaitUpdate: '/order/await/update/%s',
  orderAwaitDelete: '/order/await/delete/%s',
  getOrderAwaitList: '/order/await/list?frIdx=%s',
  orderCancelByBmOrderCode: '/order/cancelByBmOrderCode',
  expectDeliveryPrice:
    '/fr/expectDeliveryPrice?destLatitude=%s&destLongitude=%s',
  orderStatus: '/fr/order/status/count',
  orderProcList: '/order/fr/list?pageSize=%d&pageNum=%d&orderStatuses=%s',
  orderCompleteList: '/order/completeListFr',
  orderCompleteListRecent: '/order/completeListFr/recent',
  addrList: '/order/addrList?pageNum=%s&pageSize=%s',
  addrExList:
    '/order/addrAptList?pageSize=%d&pageNum=%d&searchDong=%s&searchString=%s',
  orderUpdate: '/order/update',
  orderPaymentList: '/order/orderPaymentListNotChecked',
  orderPaymentChecked: '/order/update/paymentChecked',
  orderCancel: '/order/cancel',

  //가맹점 조회시간 갱신
  updateTime: '/fr/update/lookup-time',

  //blind
  blindList: '/rider/block/list?pageSize=%d&pageNum=%d&deletedList=false',
  blindGet: '/rider/block?frIdx=%d&riderIdx=%d',
  blindAdd: '/rider/block/create',
  blindRemove: '/rider/block/delete',
  blindRemoveAll: '/rider/block/delete/all',

  //notice
  noticeList: '/user/noticeList?pageSize=%s&pageNum=%s',

  //geometry
  getGeocode: '/geometry/geocode/%s',

  // chat
  chatList: '/chat/chatList?pageSize=%s&pageNum=%s',
  chatMessageList: '/chat/messageList?pageSize=%s&pageNum=%s&chatRoomIdx=%s',
  chatListReceiver: '/chat/chatList?pageSize=%s&pageNum=%s&receiveUserIdx=%s',
  frList: '/chat/frList',
  chatSend: '/chat/send',
  chatRead: '/chat/readMessage?chatMessageIdx=%s',

  // 배송가능지역
  // getAddrBranch: "/branch/addrBranch/list?pageNum=%s&pageSize=%s",
  getAddrDelivery: '/branch/addrDelivery/list?pageNum=%s&pageSize=%s',

  // 관제 문의
  branchUserList: '/branch/user/list?branchIdx=%s&pageNum=%s&pageSize=%s',

  // 할증 정보
  getSurchargeList: '/branch/deliveryPriceExtra/list?pageNum=%s&pageSize=%s',
  getAppliedSurchargeList:
    '/branch/fr/deliveryPriceExtra/list?pageNum=%s&pageSize=%s',

  // 예치금 - 배달내역
  getDeliveryPriceSendLog: '/fr/deliveryPriceSendLog',
  getFrStat: '/fr/stat/hourly',

  // 지점정보
  getBranchInfo: '/branch/%s',

  //비밀번호 변경
  setPassword: '/user/changePassword',

  //현금내역
  cashPaymentList: '/order/cashPaymentList',

  //가맹점 지연시간
  getBasicPickupTime: '/fr/basicPickupTime',

  //주소 조회
  getAddress: '/address/getAddress?currentPage=%s&countPerPage=%s&keyword=%s',

  liveDailyDelivery: '/fr/liveDailyDeliveryByHourly',

  getCalculateHour: '/fr/calculate-hour',
  updateCalculateHour: '/fr/update/calculate-hour',

  //로컬스토리지
  storeLocalStorageToServer: '/fr/create/localStorage',
  getLocalStorageFromServer: '/fr/get/localStorage?frIdx=%s',

  getReserveOrderList: '/order/reserve/list?pageNum=%s&pageSize=%s',
  getSkinPopupList: '/skin/list?categoryList=%s&deleted=%s&branchIdx=%s',

  getEventBannerList: '/event/roulette/banner',
  getRouletteInfo: '/event/roulette/info?eventIdx=%s',
  playRoulette: '/event/roulette/play?eventIdx=%s',
};
export { serverUrl, httpExec, makeUrl, httpGet, httpUrl, httpPut, httpPost, imageUrl };
